// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/common/v1/column_profile.proto (package chalk.common.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/common/v1/column_profile.proto.
 */
export const file_chalk_common_v1_column_profile: GenFile = /*@__PURE__*/
  fileDesc("CiRjaGFsay9jb21tb24vdjEvY29sdW1uX3Byb2ZpbGUucHJvdG8SD2NoYWxrLmNvbW1vbi52MSInChRDb2x1bW5Qcm9maWxlT3B0aW9ucxIPCgdlbmFibGVkGAEgASgIIjwKF0NvbHVtblByb2ZpbGVQZXJjZW50aWxlEhIKCnBlcmNlbnRpbGUYASABKAESDQoFdmFsdWUYAiABKAEiWQodQ29sdW1uUHJvZmlsZVBlcmNlbnRpbGVMYWRkZXISOAoGcG9pbnRzGAEgAygLMiguY2hhbGsuY29tbW9uLnYxLkNvbHVtblByb2ZpbGVQZXJjZW50aWxlImYKGUNvbHVtblByb2ZpbGVEaXN0cmlidXRpb24SQAoGbGFkZGVyGAEgASgLMi4uY2hhbGsuY29tbW9uLnYxLkNvbHVtblByb2ZpbGVQZXJjZW50aWxlTGFkZGVySABCBwoFc2hhcGUizgIKDUNvbHVtblByb2ZpbGUSDgoGY29sdW1uGAEgASgJEkAKDGRpc3RyaWJ1dGlvbhgCIAEoCzIqLmNoYWxrLmNvbW1vbi52MS5Db2x1bW5Qcm9maWxlRGlzdHJpYnV0aW9uEhQKDGZpbGxlZF9jb3VudBgDIAEoAxITCgtlbXB0eV9jb3VudBgEIAEoAxIQCgNtaW4YBSABKAFIAIgBARIQCgNtYXgYBiABKAFIAYgBARIQCgNzdW0YByABKAFIAogBARIRCgRtZWFuGAggASgBSAOIAQESGwoObm9uX251bGxfY291bnQYCSABKANIBIgBARIXCgp6ZXJvX2NvdW50GAogASgDSAWIAQFCBgoEX21pbkIGCgRfbWF4QgYKBF9zdW1CBwoFX21lYW5CEQoPX25vbl9udWxsX2NvdW50Qg0KC196ZXJvX2NvdW50YgZwcm90bzM");

/**
 * Whether to profile. Carried on a request so a caller that does not render
 * distributions does not pay for them; the profiling function itself takes no
 * options, because the bin layout is a renderer decision rather than a
 * wire-format one — see `ColumnProfilePercentileLadder`.
 *
 * @generated from message chalk.common.v1.ColumnProfileOptions
 */
export type ColumnProfileOptions = Message<"chalk.common.v1.ColumnProfileOptions"> & {
  /**
   * Required. Profiles are computed only when this is true.
   *
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;
};

/**
 * Describes the message chalk.common.v1.ColumnProfileOptions.
 * Use `create(ColumnProfileOptionsSchema)` to create a new message.
 */
export const ColumnProfileOptionsSchema: GenMessage<ColumnProfileOptions> = /*@__PURE__*/
  messageDesc(file_chalk_common_v1_column_profile, 0);

/**
 * One point on a column's cumulative distribution: the value at `percentile`.
 *
 * @generated from message chalk.common.v1.ColumnProfilePercentile
 */
export type ColumnProfilePercentile = Message<"chalk.common.v1.ColumnProfilePercentile"> & {
  /**
   * The rank in 0-100 (95 for p95), matching
   * chalk.notebook.v1.NotebookDataframePercentile.
   *
   * @generated from field: double percentile = 1;
   */
  percentile: number;

  /**
   * @generated from field: double value = 2;
   */
  value: number;
};

/**
 * Describes the message chalk.common.v1.ColumnProfilePercentile.
 * Use `create(ColumnProfilePercentileSchema)` to create a new message.
 */
export const ColumnProfilePercentileSchema: GenMessage<ColumnProfilePercentile> = /*@__PURE__*/
  messageDesc(file_chalk_common_v1_column_profile, 1);

/**
 * A numeric column's distribution, as a percentile ladder ascending by rank: a
 * fixed 41-rank ladder from p0 to p100 in steps of 2.5.
 *
 * A ladder rather than pre-binned counts, deliberately — and note this is not
 * Snowsight parity, which draws histograms directly. It is the inverse CDF, so a
 * renderer can derive any bin layout it wants, at any resolution, and re-derive
 * it on zoom without another round trip, instead of the server baking a bar
 * count and a bin-edge policy into the wire format. Consecutive ranks bound
 * equal-count (quantile) bins; drawing uniform-width bars means interpolating
 * between ranks, which is coarsest in the sparse tails.
 *
 * The ladder is sketch-derived — `approx_percentile` over a KLL sketch, default
 * k=200, roughly 1.33% rank error — and interpolating bins out of it adds error
 * of its own. A renderer should mark numbers it derives from here as estimates,
 * which it can tell from this arm being the one that is set; the scalars on
 * ColumnProfile are exact and need no such caveat.
 *
 * @generated from message chalk.common.v1.ColumnProfilePercentileLadder
 */
export type ColumnProfilePercentileLadder = Message<"chalk.common.v1.ColumnProfilePercentileLadder"> & {
  /**
   * @generated from field: repeated chalk.common.v1.ColumnProfilePercentile points = 1;
   */
  points: ColumnProfilePercentile[];
};

/**
 * Describes the message chalk.common.v1.ColumnProfilePercentileLadder.
 * Use `create(ColumnProfilePercentileLadderSchema)` to create a new message.
 */
export const ColumnProfilePercentileLadderSchema: GenMessage<ColumnProfilePercentileLadder> = /*@__PURE__*/
  messageDesc(file_chalk_common_v1_column_profile, 2);

/**
 * How a column's values are distributed, as exactly one shape.
 *
 * Its own message rather than a oneof inlined into ColumnProfile: a distribution
 * is a value in its own right, so it can be passed, cached and rendered without
 * dragging the counts along, and ColumnProfile gets ordinary message presence
 * (`has_distribution`) instead of a case-is-unset check. Which arm is set is the
 * wire format's own statement of what shape the data has and how exactly it was
 * computed — no parallel enum can drift out of sync with it.
 *
 * Arms are wrapper messages because protobuf forbids `repeated` directly inside
 * a oneof. Only the ladder has a producer today; top-K frequency bars for text
 * columns and a time histogram for temporal ones would arrive as new arms.
 *
 * @generated from message chalk.common.v1.ColumnProfileDistribution
 */
export type ColumnProfileDistribution = Message<"chalk.common.v1.ColumnProfileDistribution"> & {
  /**
   * @generated from oneof chalk.common.v1.ColumnProfileDistribution.shape
   */
  shape: {
    /**
     * @generated from field: chalk.common.v1.ColumnProfilePercentileLadder ladder = 1;
     */
    value: ColumnProfilePercentileLadder;
    case: "ladder";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.common.v1.ColumnProfileDistribution.
 * Use `create(ColumnProfileDistributionSchema)` to create a new message.
 */
export const ColumnProfileDistributionSchema: GenMessage<ColumnProfileDistribution> = /*@__PURE__*/
  messageDesc(file_chalk_common_v1_column_profile, 3);

/**
 * @generated from message chalk.common.v1.ColumnProfile
 */
export type ColumnProfile = Message<"chalk.common.v1.ColumnProfile"> & {
  /**
   * @generated from field: string column = 1;
   */
  column: string;

  /**
   * Unset is a first-class state, not a protocol violation: the counts below are
   * populated whenever the profile exists at all, so a producer that can afford
   * the counts but not the distribution — no non-null values, a non-finite
   * domain, a row cap, or a column type with no producer yet — simply leaves
   * this empty, and the renderer draws the filled/empty meter alone.
   *
   * @generated from field: chalk.common.v1.ColumnProfileDistribution distribution = 2;
   */
  distribution?: ColumnProfileDistribution;

  /**
   * Legacy summarized-population count, paired with empty_count so their sum
   * is the row count. Numeric distributions and scalars use finite values;
   * counts-only fallbacks may carry non-null counts instead. Completeness UIs
   * must use non_null_count, whose meaning does not depend on profiling success.
   *
   * @generated from field: int64 filled_count = 3;
   */
  filledCount: bigint;

  /**
   * Row count minus filled_count. This can include non-finite numeric values;
   * it is not a null count. True null count is total rows minus non_null_count.
   *
   * @generated from field: int64 empty_count = 4;
   */
  emptyCount: bigint;

  /**
   * Exact domain of the column, from `min` / `max` rather than the ladder ends,
   * so a renderer can anchor an axis on a true bound. Unset when the column
   * holds no summarizable values.
   *
   * @generated from field: optional double min = 5;
   */
  min?: number;

  /**
   * @generated from field: optional double max = 6;
   */
  max?: number;

  /**
   * Exact sum and mean over the usable values. Snowsight shows both in its
   * column popover, and they cost one aggregate each in a pass already being
   * run. Unset for a column with no summarizable values, and for a
   * non-numeric one.
   *
   * @generated from field: optional double sum = 7;
   */
  sum?: number;

  /**
   * @generated from field: optional double mean = 8;
   */
  mean?: number;

  /**
   * Exact count of non-null values, including NaN and infinities. Unset when
   * the producer does not record actual nulls.
   *
   * @generated from field: optional int64 non_null_count = 9;
   */
  nonNullCount?: bigint;

  /**
   * Exact count of numeric zeros. Unset when the producer does not count zeros
   * or the column is non-numeric; an explicitly populated zero means none.
   *
   * @generated from field: optional int64 zero_count = 10;
   */
  zeroCount?: bigint;
};

/**
 * Describes the message chalk.common.v1.ColumnProfile.
 * Use `create(ColumnProfileSchema)` to create a new message.
 */
export const ColumnProfileSchema: GenMessage<ColumnProfile> = /*@__PURE__*/
  messageDesc(file_chalk_common_v1_column_profile, 4);

